import { IAddonsData } from './automations'
import { SubscriptionPlan } from './company'
import { ICoreEvent, Source } from './core-event'

export type AddonsStatus = 'ACTIVE' | 'CANCEL_AT_PERIOD_END' | 'CANCELED' | 'GRANT_PERIOD' | 'BUY'
export enum AddonsStatusEnum {
  ACTIVE                = 'ACTIVE',
  CANCEL_AT_PERIOD_END  = 'CANCEL_AT_PERIOD_END',
  CANCELED              = 'CANCELED',
  GRANT_PERIOD          = 'GRANT_PERIOD',
  BUY                   = 'BUY',
}

export enum VisibilityLevel {
  DEPARTMENT = 'DEPARTMENT',
  PERSONAL = 'PERSONAL',
  // DEPARTMENT_LEVEL = 'DEPARTMENT_LEVEL',
  // PARENT_DEPARTMENT = 'PARENT_DEPARTMENT',
  // PARENT_DEPARTMENT_LEVEL = 'PARENT_DEPARTMENT_LEVEL',
  // CHILD_DEPARTMENT = 'CHILD_DEPARTMENT',
  // CHILD_DEPARTMENT_LEVEL = 'CHILD_DEPARTMENT_LEVEL',
}

// IMPORTANT
// FOR ALL NEW ADDONS, AND A NEW ENUM. WE ALOSE NEED TO ADD THE ADDONS IN CONSTATS IN `backend/src/automations/common/automations-feature-fags.ts`
export enum AddonTypeEnum {
  OPEN_API                = 'OPEN_API',
  SHORTEST_LEAVE_INTERVAL = 'SHORTEST_LEAVE_INTERVAL',
  SYNC_SHARED_CALENDARS   = 'SYNC_SHARED_CALENDARS',
  VISIBILITY              = 'VISIBILITY',
  NO_LIMIT_TEAMS          = 'NO_LIMIT_TEAMS',
  NO_LIMIT_LOCATION       = 'NO_LIMIT_LOCATION',
  MULTI_LEVEL_APPROVAL    = 'MULTI_LEVEL_APPROVAL',
  NOTIFY_TO_WATCHERS      = 'NOTIFY_TO_WATCHERS',
  TOIL                    = 'TOIL',
}

export enum AutomationsTypeEnum {
  BLACKOUT_PERIOD             = 'BLACKOUT_PERIOD',
  SENIORITY_ENTITLEMENT       = 'SENIORITY_ENTITLEMENT',
  ENTITLEMENT_BY_ROLE         = 'ENTITLEMENT_BY_ROLE',
  PROBATION_PERIOD            = 'PROBATION_PERIOD',
  MAXIMUM_USERS_AWAY          = 'MAXIMUM_USERS_AWAY',
  LEAVE_DURATION_LIMIT        = 'LEAVE_DURATION_LIMIT',
  LEAVE_REQUEST_NOTICE_PERIOD = 'LEAVE_REQUEST_NOTICE_PERIOD',
}

export enum IntegrationsTypeEnum {
  ADP    = 'ADP',
  ZAPIER = 'ZAPIER',
}

export type AddonsType = 
  'OPEN_API' |
  'SHORTEST_LEAVE_INTERVAL' |
  'SYNC_SHARED_CALENDARS' |
  'VISIBILITY' |
  'NO_LIMIT_TEAMS' |
  'NO_LIMIT_LOCATION' |
  'MULTI_LEVEL_APPROVAL' |
  'NOTIFY_TO_WATCHERS' |
  'TOIL'

export type AutomationsType = 
  'BLACKOUT_PERIOD' |
  'SENIORITY_ENTITLEMENT' |
  'ENTITLEMENT_BY_ROLE' |
  'PROBATION_PERIOD' |
  'MAXIMUM_USERS_AWAY' |
  'LEAVE_DURATION_LIMIT' |
  'LEAVE_REQUEST_NOTICE_PERIOD'

export type IntegrationsType = 'ADP' | 'ZAPIER'
// END IMPORTANT

export interface IAddons {
  companyId: string
  automations: IAddon[]
  addons: IAddon[]
  integrations: IAddon[]
}

export interface IAddon {
  type: AddonsType | AutomationsType | IntegrationsType
  status: AddonsStatus
  isFeatureFlag?: boolean
}

export interface IUpdateAddons {
  automations?: IAddon[]
  addons?: IAddon[]
  integrations?: IAddon[]
}

export interface IDisableCanceledAddons {
  type: 'DISABLE-CANCELED-ADDONS'
  meta: {}
  payload: IDisableCanceledAddonsPayload
}

export interface IDisableCanceledAddonsPayload {
  correlationId: string
  source: Source
  companyId: string
  creator: string
}

export interface IAddonVisibilityForm {
  formatMessage: Function
  amIAdmin: boolean
  authUserId: string
  dateFormat: string
  handleSubscribe: (id: string, isActive: boolean) => void
  status?: AddonsStatus
  backToAddons: () => void
  addonDetails?: IAddonsData
  currentPlan?: SubscriptionPlan
}
export interface IAddonVisibilityCreatedUpdatedEvent extends ICoreEvent {
  automationId: string
  creator: string
  eventType: 'VISIBILITY_ADDON_CREATED' | 'VISIBILITY_ADDON_UPDATED'
  validityStart: string
  automationType: 'VISIBILITY'
  isActive: boolean
  groupKey: string
  companyId: string
  visibilityLevel: VisibilityLevel[]
  correlationId: string
  eventGroup: 'AUTOMATION'
  timestamp: string
}

export interface IAddonVisibility {
  companyId: string
  id: string
  automationType: 'VISIBILITY'
  createdAt: string
  isActive: boolean
  owner: string
  visibilityLevel: string[]
}

export interface IAddonOpenApiCreatedEvent extends ICoreEvent {
  automationId: string
  creator: string
  eventType: 'OPEN_API_ADDON_CREATED'
  validityStart: string
  automationType: 'OPEN_API'
  isActive: boolean
  groupKey: string
  companyId: string
  correlationId: string
  eventGroup: 'AUTOMATION'
  timestamp: string
  name: string
}

export interface IAddonOpenApiDeletedEvent extends ICoreEvent {
  eventType: 'OPEN_API_ADDON_DELETED'
  eventGroup: 'AUTOMATION'
  automationId: string
}

export interface IAddonOpenApiKey {
  companyId: string
  id: string
  automationType: 'OPEN_API'
  createdAt: string
  owner: string
  name: string
  apiKeyValue: string
  apiKeyId: string
}
